import React from 'react';
import PropTypes from 'prop-types';
import { UiIcon, UiButton } from 'ui-components';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { getDateTime } from 'utils';
import { useTranslation } from 'react-i18next';
import { StyledChangePasswordNotif } from './ChangePasswordNotif.styles';

const ChangePasswordNotif = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { time: dateTime, isRead, days_to_expired: daysToExpired } = props;
  const { date, time } = getDateTime(dateTime);
  return (
    <StyledChangePasswordNotif>
      <div className={classNames('change-Password-Notif')}>
        <div className='flex gap-10'>
          {/* نقطه اول خط */}
          {!isRead && <span className='bullet'></span>}

          {/* آیکن */}
          <UiIcon icon='ri-lock-line' color='#F7936F' hover='#F7936F' />

          {/* متن پیشفرض */}
          <span className='title'>{t('notifications:changePassword')}</span>

          {/* تاریخ دریافت */}
          <bdi className='date-time'>
            <span className='mr-5'>{date}</span>
            {time}
          </bdi>
        </div>

        {/* عنوان */}
        <h3 className='message'>
          <span>
            {t('notifications:remainingDaysToExpirePassword', {
              daysToExpired,
            })}
          </span>
        </h3>

        {/* دکمه دانلود */}
        <UiButton
          variant='outlined'
          fullWidth
          color='secondary'
          style={{ color: '#F7936F' }}
          onClick={() => navigate('/change-password')}
        >
          <div className='flex between'>
            <UiIcon
              icon='ri-lock-line'
              color='#F7936F'
              hover='#F7936F'
              className='ml-10'
            />
            <span>{t('notifications:changePassword')}</span>
          </div>
        </UiButton>
      </div>
    </StyledChangePasswordNotif>
  );
};

ChangePasswordNotif.propTypes = {
  time: PropTypes.string,
  days_to_expired: PropTypes.number,
  isRead: PropTypes.number,
};

export default ChangePasswordNotif;
